"use strict";
import { gqlToCurrency } from "appGraphql/data/util";
import { PortfolioLogo } from "components/AccountDrawer/MiniPortfolio/PortfolioLogo";
import { NATIVE_CHAIN_ID } from "constants/tokens";
import useNativeCurrency from "lib/hooks/useNativeCurrency";
import { useMemo } from "react";
import { getChainInfo } from "uniswap/src/features/chains/chainInfo";
import { UniverseChainId } from "uniswap/src/features/chains/types";
import { getChainIdFromChainUrlParam } from "utils/chainParams";
function getTokenProjectLogoUrl(token) {
  const projectLogoUrl = token?.project && "logoUrl" in token.project ? token.project.logoUrl : void 0;
  const projectLogo = token?.project && "logo" in token.project ? token.project.logo?.url : void 0;
  const tokenLogo = token && "logo" in token && typeof token.logo === "string" ? token.logo : void 0;
  return projectLogoUrl ?? projectLogo ?? tokenLogo ?? void 0;
}
export default function QueryTokenLogo(props) {
  const chainId = getChainIdFromChainUrlParam(props.token?.chain.toLowerCase()) ?? UniverseChainId.Mainnet;
  const isNative = props.token?.address === NATIVE_CHAIN_ID;
  const isTokenStat = !!props.token && "volume" in props.token;
  const nativeCurrency = useNativeCurrency(chainId);
  const currency = isNative ? nativeCurrency : props.token && !isTokenStat ? gqlToCurrency(props.token) : void 0;
  const logoUrl = getTokenProjectLogoUrl(props.token);
  const currencies = useMemo(
    () => isTokenStat && !isNative ? void 0 : [currency],
    [currency, isNative, isTokenStat]
  );
  return <PortfolioLogo currencies={currencies} chainId={chainId} images={[logoUrl]} {...props} />;
}
export function QueryRingTokenLogo(props) {
  const chainId = getChainIdFromChainUrlParam(props.token?.chain.toLowerCase()) ?? UniverseChainId.Mainnet;
  const isNative = props.token?.address === NATIVE_CHAIN_ID;
  const nativeLogo = getChainInfo(chainId).nativeCurrency.logo;
  const nativeLogoUrl = typeof nativeLogo === "string" ? nativeLogo : void 0;
  const logoUrl = getTokenProjectLogoUrl(props.token);
  return <PortfolioLogo chainId={chainId} images={[isNative ? nativeLogoUrl : logoUrl]} {...props} />;
}
